exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.customers-table{height:75vh;font-size:9pt}.customers-table .fa-check-square{color:green}.customers-table .fa-window-close{color:red}.customers-table .customers-table-style-actions{min-width:120px}.customers-table .customers-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.customers-table .customers-table-style-phone{min-width:105px}.customers-table .customers-table-style-th-datetime{min-width:110px}.customers-table .customers-table-style-td-datetime{text-align:center}.customers-table .match-name-col{width:75%}", ""]);

// exports
